import React, { FC } from "react";
import { AppBar, Container as ContainerMui, Grid, Paper } from "@mui/material";
import { iContainer } from './types';

export const Container: FC<iContainer> = ({ children }) => {
  return (
    <ContainerMui maxWidth={false} className="container-view MuiTab-root">
      <Paper elevation={0}>
        <AppBar
          position="static"
          elevation={0}
          style={{ backgroundColor: "white", color: "black" }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid
              item
              xs
              container
              direction="row"
              justifyContent={"flex-start"}
              alignItems="flex-start"
            >
              <Grid item xs>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </AppBar>
      </Paper>
    </ContainerMui>
  );
};
